import React, { useState, useEffect, useRef } from 'react';
import './PhotoGallery.css';

// Import your images
import image1 from '../assets/8.jpg';
import image2 from '../assets/1.jpg';
import image3 from '../assets/3.jpg';
import image4 from '../assets/2.jpg';
import image5 from '../assets/4.jpg';
import image6 from '../assets/5.jpg';
import image7 from '../assets/6.jpg';
import image8 from '../assets/7.jpg';

const imagePaths = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
];

const PhotoGallery = () => {
  const [inView, setInView] = useState(false);
  const galleryRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true);
          } else {
            setInView(false);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    if (galleryRef.current) {
      observer.observe(galleryRef.current);
    }

    return () => {
      if (galleryRef.current) {
        observer.unobserve(galleryRef.current);
      }
    };
  }, []);

  return (
    <div className="photo-gallery-container" ref={galleryRef}>
      <div className="gallery-header">
      <h4
          style={{
            fontWeight: '500',
            color: '#D4A762',
            fontSize: '18px',
            marginBottom: '20px',
            letterSpacing: '1px',
            transform: inView ? 'translateY(0) translateX(0)' : 'translateY(30px)',
            opacity: inView ? 1 : 0,
            transition: inView
              ? 'transform 1s ease-out 0.3s, opacity 1s ease-out 0.3s'
              : 'none', // 'none' when not in view, so it resets instantly
          }}
        >
          BEST PHOTOS RESTAURANT
        </h4>
        
        <h3
          className="gallery-title"
          style={{
            fontWeight: '500',
            transform: inView ? 'translateY(0) translateX(0)' : 'translateY(30px)',
            opacity: inView ? 1 : 0,
            transition: inView
              ? 'transform 1s ease-out 0.5s, opacity 1s ease-out 0.5s'
              : 'none', // 'none' when not in view
          }}
        >
          Pictures Of Our Restaurant
        </h3>
      </div>

      <div className={`grid-gallery ${inView ? 'animate-images' : ''}`}> {/* Add 'animate-images' class conditionally */}
        {imagePaths.map((src, index) => (
          <div key={index} className={`grid-item div${index + 1}`}>
            <img src={src} alt={`Restaurant ${index + 1}`} loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PhotoGallery;